export const generateICalendar = (scheduleData: any) => {
    const formatDateTime = (date: string, time: string) => {
      const [hour, minute] = time.split(":");
      const d = new Date(date);
      d.setHours(Number(hour), Number(minute), 0);
      return d.toISOString().replace(/[-:]/g, "").split(".")[0];
    };
  
    const getWeekdayCode = (weekday: number) => {
      const weekdayMap: { [key: number]: string } = {
        1: "MO",
        2: "TU",
        3: "WE",
        4: "TH",
        5: "FR",
        6: "SA",
        7: "SU",
      };
      return weekdayMap[weekday];
    };
  
    let icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Trakia-University//NONSGML v1.0//EN\n`;
  
    scheduleData.forEach((event: any) => {
      const startDate = formatDateTime(event.startDate, event.startHour);
      const endDate = formatDateTime(event.startDate, event.endHour);
  
      let eventContent = `BEGIN:VEVENT
UID:${event.subjectName}-${event.startDate}-${event.startHour}@trakia-uni.bg
DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").split(".")[0]}Z
DTSTART:${startDate}
SUMMARY:${event.subjectName}
DESCRIPTION:${event.activityTypeName} - ${event.groupName} - ${event.specialityName}
LOCATION:${event.hallNumber}
STATUS:CONFIRMED\n`;
  
      if (event.oneTimeEvent) {
        eventContent += "";
      } else if (event.oneTimePeriodEvent && event.endDate) {
        eventContent += `DTEND:${formatDateTime(event.endDate, event.endHour)}\n`;
      } else if (event.weekDay != null && event.startWeek && event.endWeek) {
        const weekdayCode = getWeekdayCode(event.weekDay);
        const recurrenceEndDate = new Date(event.startDate);
        recurrenceEndDate.setDate(
          recurrenceEndDate.getDate() + (event.endWeek - event.startWeek + 1) * 7
        );
  
        eventContent += `RRULE:FREQ=WEEKLY;BYDAY=${weekdayCode};UNTIL=${recurrenceEndDate
          .toISOString()
          .replace(/[-:]/g, "")
          .split(".")[0]}Z\n`;
      } else if (event.weekDay != null) {
        const weekdayCode = getWeekdayCode(event.weekDay);
        eventContent += `RRULE:FREQ=WEEKLY;BYDAY=${weekdayCode}\n`;
      }
  
      eventContent += "END:VEVENT\n";
      icsContent += eventContent;
    });
  
    icsContent += "END:VCALENDAR";
  
    const blob = new Blob([icsContent], { type: "text/calendar" });
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement("a");
    link.href = url;
    link.download = "schedule.ics";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  